import React from 'react';
import { ConnectionTypeModel, DataConnectionType } from '../types';

interface DataSourcePropertiesStepProps {
    name: string;
    type?: DataConnectionType;
    connectionTypes: ConnectionTypeModel[];
    errors: Record<string, string>;
    onNameChange: (value: string) => void;
    onTypeChange: (value: DataConnectionType) => void;
}

const DataSourcePropertiesStep: React.FC<DataSourcePropertiesStepProps> = ({
    name,
    type,
    connectionTypes,
    errors,
    onNameChange,
    onTypeChange,
}) => (
    <div className="data-sources-step data-sources-properties-step">
        <div className="data-sources-form-stack">
            <label className="data-sources-field">
                <span>{InovxLoader.t('facility:dataSources.fields.name')}</span>
                <input
                    type="text"
                    className={errors.name ? 'invalid' : ''}
                    value={name}
                    onChange={event => onNameChange(event.target.value)}
                    maxLength={256}
                />
                {errors.name && <span className="data-sources-field-error">{errors.name}</span>}
            </label>
            <label className="data-sources-field">
                <span>{InovxLoader.t('facility:dataSources.fields.provider')}</span>
                <select
                    className={errors.type ? 'invalid' : ''}
                    value={type || ''}
                    onChange={event => onTypeChange(Number(event.target.value) as DataConnectionType)}
                >
                    <option value="">{InovxLoader.t('facility:dataSources.placeholders.selectProvider')}</option>
                    {connectionTypes.map(connectionType => (
                        <option key={connectionType.Type} value={connectionType.Type}>
                            {connectionType.DisplayName || connectionType.Name}
                        </option>
                    ))}
                </select>
                {errors.type && <span className="data-sources-field-error">{errors.type}</span>}
            </label>
        </div>
    </div>
);

export default DataSourcePropertiesStep;
